export const enUS = {
  panelTitle: "Advisor Panel",
  managerPanelTitle: "Manager Panel",
  importData: "Import data",
  rankingSectionTitle: "Product ranking by market",
  rankingExampleCriterion: "FICs and REITs with the highest liquidity exposure over the next 30 days.",
  opportunityVolumeLabel: "Opportunity value",
  rankingPreviewShow: "View product rankings by market",
  rankingPreviewHide: "Hide product rankings by market",
  rankingPreviewLoadError: "Could not load rankings from the server.",
  rankingPreviewNotConfigured: "No criterion defined.",
  rankingPreviewEditedMeta: "Last edited: {name} · {date}",
  rankingEditForbidden: "Only managers can change rankings. Use the Manager panel.",
  rankingViewProperties: "View ranking properties",
  rankingHideProperties: "Hide ranking properties",
  rankingPropertiesModalTitle: "Properties — {market}",
  rankingPropertiesLoadError: "Could not load ranking properties.",
  rankingPropertiesEmpty: "No properties available for this market.",
  rankingPropertiesClickHint:
    "Click a property or value to build your criterion in the field below.",
  rankingClarificationOtherOption: "Other (specify)",
  rankingClarificationFreeformPlaceholder: "Type your answer",
  rankingClarificationConfirm: "Confirm answers",
  rankingClarificationSubmitError: "Could not send your answer. Please try again.",
  rankingPropertiesOrderingTitle: "Order by",
  rankingPropertiesFilteringTitle: "Filter by",
  rankingPropertiesExpandModal: "Expand",
  rankingPropertyHigher: "higher",
  rankingPropertyLower: "lower",
  rankingPropertyNewer: "newer",
  rankingPropertyOlder: "older",
  rankingPropertyFilterGt: "greater than…",
  rankingPropertyFilterLt: "less than…",
  rankingPropertyFilterAfter: "after…",
  rankingPropertyFilterBefore: "before…",
  rankingPropertyFilterValuePlaceholder: "Value",
  rankingPropertyFilterDatePlaceholder: "Date (e.g. 2020-01-15)",
  rankingPropertyFilterApply: "Insert",
  rankingPropertyFilterCancel: "Cancel",
  rankingPropertyFilterInvalidValue: "Enter a valid number.",
  rankingPropertyFilterInvalidDate: "Enter a date.",
  rankingPropertyYes: "yes",
  rankingPropertyNo: "no",
  rankingChatPlaceholder: "E.g. highest return, lowest liquidity… (use properties above)",
  rankingConfirmHint: "Confirm to apply this ranking to the market, or cancel to discard it.",
  rankingConfirmButton: "Confirm and apply",
  rankingCancelButton: "Cancel suggestion",
  rankingConfirmUserMessage: "Confirm",
  rankingCancelUserMessage: "Cancel",
  chatMessageSendError: "Could not send your message. Please try again.",
  chatStreamingStarting: "Starting...",
  opportunitiesOnManagerPanel:
    "Opportunities and creating new objectives are on the Manager panel. Use the tab above to switch.",
  clientsOverview: "Clients Overview",
  // Consolidated execution overview (Manager panel)
  periodMTD: "MTD",
  periodYTD: "YTD",
  periodCustom: "Custom",
  periodCustomStart: "Start",
  periodCustomEnd: "End",
  vsPreviousPeriod: "vs. previous period",
  executionPerformanceOverviewTitle: "Consolidated execution overview",
  executionPerformanceOverviewSubtitle:
    "How much of the volume offered in opportunities actually turned into movements in the selected window.",
  executionPerformanceLoadError: "Could not load the consolidated execution overview from the server.",
  executionCombinedCardLabel: "Opportunity execution",
  executionAverageLabel: "Consolidated",
  advisorCurvesTitle: "Execution curve for the period",
  executionNoDataInWindow: "No movement linked to an opportunity in this window.",
  executionByAdvisorTitle: "Performance by advisor",
  executionByOpportunityTitle: "Performance by opportunity",
  executionUnassignedAdvisor: "No advisor",
  executionUntitledOpportunity: "Untitled opportunity",
  basisSettled: "Settled",
  basisWithPending: "Including in flight",
  executionPendingHint: "{value} requested, not settled yet",
  unitVolume: "Financial volume",
  unitClients: "Client count",
  scatterAxisLabel: "Horizontal axis: {xAxisLabel} · Vertical axis: {yAxisLabel}",
  scatterYAxisVolumeLabel: "executed volume (R$)",
  scatterYAxisClientsLabel: "executed clients",
  scatterXAxisExecutionLabel: "execution performance (%)",
  scatterQuadrantFavorable: "Favorable on both axes",
  scatterQuadrantUnfavorable: "Unfavorable on both axes",
  scatterQuadrantMixed: "Favorable on only one axis",
  VolumeUnderCustody: "Volume Under Custody",
  opportunities: 'Opportunities',
  objectiveDraftModalTitle: "New objective",
  objectiveDraftReviewTitle: "Review draft",
  objectiveDraftIntro:
    "Describe the strategy in plain language. We will generate a draft: the model proposes an interpretation and a read-only query. You can refine the text and regenerate, or confirm to save.",
  objectivePromptLabel: "Strategy (prompt)",
  objectivePromptHelper: "Main text the model uses to understand the objective and estimate impact. Clearer prompts yield better drafts.",
  objectiveReportTitleLabel: "Report name (optional)",
  objectiveCardStrategyLabel: "Strategy",
  objectiveStartDateLabel: "Start date",
  objectiveStartDateHelper:
    "Today or a past date. Defines the reference portfolio of the impacted clients.",
  objectiveStartDateFutureError: "Start date cannot be in the future.",
  objectiveEndDateBeforeStartError: "End date must be after the start date.",
  objectiveGenerateDraftButton: "Generate draft",
  objectiveReviewHeading: "Draft review (nothing saved yet)",
  objectiveExpiresHint: "This draft expires at",
  objectiveInterpretationHeading: "Model interpretation",
  objectiveCypherHeading: "Generated query (read-only)",
  objectiveImpactedPreviewHeading: "Impact preview",
  objectiveImpactedCount: "Estimated row count",
  objectiveWarningsHeading: "Warnings",
  objectiveStrategyAdjustLabel: "Adjust strategy text and regenerate",
  objectiveRegenerateButton: "Regenerate draft",
  objectiveCommitButton: "Confirm and save objective",
  objectiveBackToFormButton: "Back to form",
  objectivePreviewEmpty: "No preview rows.",
  objectiveDraftCannotCommit:
    "The query was not validated. Adjust the strategy or regenerate the draft before confirming.",
  objectiveCommitSuccess: "Objective created successfully.",
  opportunityCreatedNotification: "New opportunity: {title}",
  opportunityUpdatedNotification: "Opportunity updated: {title}",
  opportunityDeletedNotification: "Opportunity removed: {title}",
  opportunityUntitled: "Untitled",
  objectiveMonitoringBadge: "Monitoring",
  objectiveSeeByPortfolio: "View by portfolio",
  objectiveHidePortfolio: "Hide portfolios",
  objectiveMonitorAction: "Monitor",
  objectiveMonitorCollapse: "Hide",
  objectiveMonitoringMeta: "{portfolioCount} portfolios · {movementCount} movements",
  objectiveMonitoringSummary: "Execution Summary",
  objectiveMonitoringSummaryOfTotal: "of {total}",
  objectiveMonitoringPortfolioCol: "Portfolio",
  objectiveMonitoringAdvisorCol: "Advisor",
  objectiveMonitoringAmountCol: "Net amount",
  objectiveMonitoringOpportunityTotalCol: "Opportunity value (See clients)",
  objectiveMonitoringPercentDoneCol: "Percent done",
  objectiveMonitoringNA: "N/A",
  objectiveMonitoringSortHintDesc: "Sorted: highest % done first",
  objectiveMonitoringSortHintAsc: "Sorted: lowest % done first",
  objectiveMonitoringSortToggleAria: "Toggle sort order for percent done",
  objectiveMonitoringNoAdvisor: "No advisor",
  objectiveMonitoringGroupModePortfolio: "By portfolio",
  objectiveMonitoringGroupModeAdvisor: "By advisor",
  objectiveMonitoringGroupModeAria: "Switch between portfolio and advisor aggregation",
  objectiveMonitoringViewTimeline: "Timeline",
  objectiveMonitoringViewChart: "Bars",
  objectiveMonitoringViewTable: "Table",
  objectiveMonitoringViewAria: "Switch between timeline, bars and table",
  objectiveMonitoringMetricVolume: "Volume",
  objectiveMonitoringMetricClients: "Clients",
  objectiveMonitoringMetricAria: "Switch metric between financial volume and clients done",
  objectiveMonitoringChartTitle: "Percent done by advisor",
  objectiveMonitoringChartAxisHint: "0% — 100%",
  objectiveMonitoringChartPortfolios: "Portfolios",
  objectiveMonitoringChartConsolidated: "Consolidated",
  objectiveMonitoringChartEmpty: "No advisor data to show on the chart.",
  objectiveMonitoringOpportunityShort: "Opportunity value",
  objectiveMonitoringByAdvisorTitle: "Execution by advisor",
  objectiveMonitoringClientsCol: "Clients done",
  objectiveMonitoringClientsDoneShort: "{done}/{total} clients",
  objectiveMonitoringClientsDoneLabel: "{done} of {total} clients done",
  objectiveMonitoringClientDone: "Done",
  objectiveMonitoringClientNotDone: "Not done",
  objectiveMonitoringClientStatusCol: "Status",
  objectiveMonitoringClientsAdesaoHint: "Coverage: clients with executed volume above 0%",
  objectiveMonitoringVolumeHint: "Percent of financial volume executed",
  objectiveMonitoringTimelineTitle: "Execution over time",
  objectiveMonitoringTimelineHint: "Cumulative from campaign start through today (or the due date)",
  objectiveMonitoringTimelineHintByAdvisor:
    "One line per advisor who executed · cumulative in the campaign window",
  objectiveMonitoringTimelineTotal: "Total",
  objectiveMonitoringTimelineMoreAdvisors: "+{count} advisors",
  objectiveMonitoringTimelineDaily: "Day volume",
  objectiveMonitoringTimelineCumulative: "Cumulative",
  objectiveMonitoringTimelineMovements: "{count} movements",
  objectiveMonitoringTimelineEmpty: "No campaign date window to build the timeline.",
  objectiveMonitoringDrilldownEmpty: "Select one or more advisors on the left to see portfolios.",
  objectiveMonitoringSelectedSummaryLabel: "Selected ({count})",
  objectiveMonitoringEmpty:
    "No portfolio monitoring data for this objective (or no stored movement query).",
  objectiveMonitoringRollupsHint:
    "Load portfolio rollups once to see movements for this and other monitored objectives.",
  // Aggregated opportunities comparison (multi-select on the manager panel)
  aggOpportunitiesBadge: "Comparison",
  aggOpportunitiesTitle: "Aggregated execution by advisor",
  aggOpportunitiesSubtitle:
    "{count} opportunities · single global-progress bar per advisor; each slice = opportunity contribution (weight × execution)",
  aggOpportunitiesNoAdvisor: "No advisor",
  aggOpportunitiesPotentialLabel: "Potential",
  aggOpportunitiesExecutedLabel: "Executed",
  aggOpportunitiesExecutionLabel: "Execution",
  aggOpportunitiesAvgCol: "Global %",
  aggOpportunitiesShareSuffix: "of advisor total",
  aggOpportunitiesGlobalProgressSuffix: "of global progress",
  aggOpportunitiesByAdvisorTitle: "Advisors",
  aggOpportunitiesByAdvisorHint:
    "Value-weighted global progress · under the name: unique clients done (execution > 0%) · click to drill down",
  aggOpportunitiesDrilldownTitle: "Breakdown by opportunity and portfolio",
  aggOpportunitiesDrilldownEmpty: "Select one or more advisors on the left.",
  aggOpportunitiesCarteirasTitle: "Portfolios",
  aggOpportunitiesEmpty: "No opportunity value to display.",
  welcomeText1: "Welcome back",
  todayIs: "Today is",
  itIsTime: "It is",
  dueDate: "Due date",
  objectiveExpiredLabel: "Expired on",
  expiredBadge: "Expired",
  showExpiredOpportunities: "Expired opportunities",
  statusFilterLabel: "Status",
  statusActive: "Active",
  statusAll: "All",
  statusExpired: "Expired",
  editObjectiveModalTitle: "Edit opportunity",
  editObjectiveSuccess: "Opportunity updated successfully.",
  objectiveEditTitleLabel: "Title",
  objectiveEditWindowHint:
    "The start date defines the reference portfolio of the impacted clients; changing it recomputes the opportunity's links.",
  startDate: "Start",
  editObjectiveAria: "Edit opportunity",
  cancel: "Cancel",
  save: "Save",
  saving: "Saving...",
  seeMore: "See more",
  contextMessage: "Context",
  commitments: "Commitments",
  openFinance: "Open Finance",
  accountLabel: "Account",
  financialInstitution: "Institution",
  nextContributionPerClient: "Próximos vencimentos e aportes de clientes",
  // Commitments section redesign (phase 3) — allocation by strategy
  allocationByStrategyTitle: "Allocation by strategy",
  allocationByStrategyEmpty: "No allocation data available",
  allocationByStrategyNoAllocation: "Client has no holdings allocated to a strategy",
  allocationByStrategyNoReferenceProfile: "Client's profile doesn't match any reference portfolio",
  allocationByStrategyDataUnavailable: "Data unavailable",
  allocationByStrategySimulated: "Simulated",
  allocationStrategyPosfixado: "Post-fixed",
  allocationStrategyPrefixado: "Pre-fixed",
  allocationStrategyInflacao: "Inflation-linked",
  allocationStrategyRendaVariavel: "Equities",
  allocationStrategyRetornoAbsoluto: "Absolute Return/MM",
  allocationStrategyAlternativo: "Alternatives",
  allocationStrategyNaoInformada: "Unclassified",
  allocationStrategyRendaFixaGlobal: "Global Fixed Income",
  allocationStrategyRendaVariavelGlobal: "Global Equities",
  allocationStrategyInternacional: "International",
  allocationStrategyMultimercado: "Multi-strategy",
  allocationStrategyNaoClassificada: "Unclassified",
};